import { IBFRecordParsingDefinition } from "@/lib/drivers/insulet/IBFRecords/RecordParser";
import { Version } from "@/lib/drivers/insulet/OmnipodTypes";

type IBFVersion = {
  ibfVersion: Version;
  engineVersion: Version;
  vendorId: string;
  productId: string;
};

export const IBF_VERSION = {
  // Value is just the order in which the items are present in the file
  value: 1,
  name: "IBF_VERSION",
  size: 22, // 3 bytes for each version + 8 bytes for vendorId and productId
  parse: record => {
    const ibfVersion = record.nextVersion();
    const engineVersion = record.nextVersion();
    const vendorId = record.nextString(8);
    const productId = record.nextString(8);
    return {
      ibfVersion,
      engineVersion,
      vendorId,
      productId,
    };
  },
} satisfies IBFRecordParsingDefinition<IBFVersion>;
